"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cronStringToLikeMap = exports.CronLikeToString = void 0;
const CronLikeToString = (cronOb) => {
    let cronString = `${cronOb.minute.join(',')} ${cronOb.hour.join(',')} ${cronOb.dayOfMonth.join(',')} ${cronOb.month.join(',')} ${cronOb.dayOfWeek.join(',')}`;
    return cronString;
};
exports.CronLikeToString = CronLikeToString;
const { projectCode, stage } = process.env;
const mapper = (x) => {
    const nan = isNaN(parseInt(x));
    return nan ? x : parseInt(x);
};
const cronStringToLikeMap = (cronString) => {
    const arr = cronString.split(' ');
    const map = {
        minute: arr[0].split(',').map(mapper),
        hour: arr[1].split(',').map(mapper),
        dayOfMonth: arr[2].split(',').map(mapper),
        month: arr[3].split(',').map(mapper),
        dayOfWeek: arr[4].split(',').map(mapper),
    };
    return map;
};
exports.cronStringToLikeMap = cronStringToLikeMap;
